export default "__VITE_ASSET__3847dbfa__"